// extracted by mini-css-extract-plugin
export var bio = "styles-module--bio--27275";
export var container = "styles-module--container--9c4b4";
export var name = "styles-module--name--2ca4f";
export var subcategory = "styles-module--subcategory--9c5f0";
export var topRow = "styles-module--topRow--fc40b";